import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'
import { orderPaymentFragment } from '@ztechapps/order.common'

const addressFragment = `
    _id
    street1
    street2
    city
    state
    zip
    country
    fullAddress
    company
    street3
    name
    phone
`

export const paymentFragment = `payments {
    _id
    status
    date
    method
    remarks
    stripeInfo {
      _id
      paymentIntent
      paymentId
      sessionId
    }
    merchantFee
    net
    gross
    refunds {
      _id
      amount
      remarks
      date
      status
    }
    relatedOrderId
    checkNumber
    checkDate
  }
    `

export const paymentBalanceFragment = `
  paymentBalance {
    _id
    balance
    totalPaid
  }
`
export const orderCheckoutFragment = gql`
  fragment orderCheckoutFragment on Order {
    _id
    code
    status
    updatedAt
    createdAt
    net
    gross
    shippingFee
    isManualShippingRate
    allowPrePayment
    remarks
    by {
      _id
      profile {
        _id
        name
        picture
        email
      }
      status
      phone
      address {
        _id
        fullAddress
        street1
      }
      company {
        _id
        name
      }
      ups {
        _id
        account
        postalCode
        countryCode
      }
    }
    items {
      _id
      product {
        _id
        code
        name
        coverImage
        status
        inventory {
          _id
          quantityOnHand
        }
        requiredComputedQuantityOnHand
        hasSubComponents
      }
      quantity
      price
      net
      remarks
    }
    discount
    taxAmount
    customerPoNumber
    allItemsInStock
    allItemsInStockByOnHandAndComputedQuantity
    shippingAddress {
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      company
      street3
      name
      phone
    }
    billingAddress {
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      company
      street3
      name
      phone
    }

    shipping {
      _id
      billToAccount
      billToCountryCode
      billToPostalCode
      billToCustomer
      deliveryConfirmation
      insuredAmount
      shipmentId
      date
      serviceErrors
      rate {
        _id
        shippingAmount
        deliveryDays
        estimatedDeliveryDate
        serviceType
        carrierName
        serviceCode
        carrierId
        markupCost
        shippingCost
      }
      packages {
        _id
        weight {
          _id
          value
          unit
        }
        dimensions {
          _id
          height
          width
          length
          unit
        }
        insured_value {
          _id
          amount
          currency
        }

        package_id
        package_code
        sequence
        trackingUrl
        packageType
      }
    }
    totalWeight
    payments {
      ...orderPaymentFragment
    }
    checkoutStage
    paymentBalance {
      _id
      balance
      totalPaid
    }
    paymentStatus
  }

  ${orderPaymentFragment}
`

export const queries = buildGraphqlQuery('Order', orderCheckoutFragment)

export const shippingFeeUpdateQuery = buildGraphqlQuery(
  'Order',
  `_id
  updatedAt
  net
  gross
  shippingFee`
)

export const shippingAddressQuery = buildGraphqlQuery(
  'Order',
  `_id shippingAddress {
    ${addressFragment}
  }  `
)

export const customerAddressQuery = buildGraphqlQuery(
  'Customer',
  `_id address {
    ${addressFragment}
  }  `
)

export const shippingGetRatesQuery = gql`
  query orderGetShippingRates($filter: GetOrderShippingRatesArgs) {
    orderGetShippingRates(filter: $filter) {
      _id
      shippingAmount
      deliveryDays
      estimatedDeliveryDate
      serviceType
      carrierName
      serviceCode
      carrierId
      markupCost
      shippingCost
    }
  }
`

export const orderConfirmQuery = gql`
  mutation orderConfirm($input: JSON!) {
    orderConfirm(input: $input) {
      _id
      status
      communication {
        _id
      }
    }
  }
`

export const orderPayQuery = gql`
  ${orderCheckoutFragment}
  mutation orderPay($input: JSON) {
    orderPay(input: $input) {
      _id
      ...orderCheckoutFragment
    }
  }
`

export const orderFulfillPaymentQuery = gql`
  ${orderCheckoutFragment}
  mutation orderFulfillPayment($input: JSON) {
    orderFulfillPayment(input: $input) {
      _id
      ...orderCheckoutFragment
    }
  }
`
